import React from 'react';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import IconButton from '@mui/material/IconButton';
var NodeExpandButton = function (_a) {
    var expanded = _a.expanded, setExpanded = _a.setExpanded;
    var handleClick = function (e) {
        e.stopPropagation();
        setExpanded && setExpanded(!expanded);
    };
    return (React.createElement("div", { className: "nodeExpandButton" + (expanded ? ' nodeExpandButton--expanded' : '') },
        React.createElement(IconButton, { size: "small", color: "primary", onClick: handleClick },
            React.createElement("div", { className: "nodeExpandButton__background" }),
            React.createElement(AccurityIcon, { className: "nodeExpandButton__icon", iconName: expanded ? 'mui:RemoveCircle' : 'mui:AddCircle' }))));
};
export default NodeExpandButton;
//# sourceMappingURL=NodeExpandButton.js.map